import { render, staticRenderFns } from "./ChatBoxTextImg.vue?vue&type=template&id=604568ac&scoped=true"
import script from "./ChatBoxTextImg.vue?vue&type=script&lang=js"
export * from "./ChatBoxTextImg.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxTextImg.vue?vue&type=style&index=0&id=604568ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604568ac",
  null
  
)

export default component.exports